import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'
import { PRODUCT_OPTIONS } from './Constants'

const ListaCatalogoView = WithErrorBoundary(
  'Producto',
  'Error en Lista de Productos',
  React.lazy(() => import('./ListaCatalogoView')),
)
const FormularioCatalogo = WithErrorBoundary(
  'Producto',
  'Error en Formulario de Producto',
  React.lazy(() => import('./FormularioCatalogo')),
)

const SavingsPlan = WithErrorBoundary(
  'Producto',
  'Error en Formulario de Producto',
  React.lazy(() => import('./SavingsPlan.container')),
)

export default {
  path: '/car-catalogo',
  name: 'Car data catalogo',
  childRoutes: [
    { path: '', name: 'Lista', component: ListaCatalogoView, isIndex: true },
    { path: 'crear/' + PRODUCT_OPTIONS.planAhorro + '/:id', name: 'Formulario catalogo', component: SavingsPlan },
    { path: 'editar/' + PRODUCT_OPTIONS.planAhorro + '/:id', name: 'Formulario catalogo', component: SavingsPlan },
    { path: 'ver/' + PRODUCT_OPTIONS.planAhorro + '/:id', name: 'Formulario catalogo', component: SavingsPlan },
    { path: 'crear/:tipo', name: 'Formulario catalogo', component: FormularioCatalogo },
    { path: 'crear/:tipo/:id', name: 'Formulario catalogo', component: FormularioCatalogo },
    { path: 'editar/:id', name: 'Formulario catalogo', component: FormularioCatalogo },
    { path: 'ver/:id', name: 'Formulario catalogo', component: FormularioCatalogo },
  ],
}
